// page : '/obsrec/kansatsukiroku/:koujibangou/__NEW__'

// react reduc react-redux react-cropper history uuid moment
import * as React from 'react';
import { Dispatch, Action } from 'redux';
import { connect } from 'react-redux';
import Cropper from 'react-cropper';
import * as H from 'history';
import { v4 as uuidv4 } from 'uuid';
import * as moment from 'moment';
// css
import 'cropperjs/dist/cropper.css';
// material-ui
import { Typography, Paper, Button, Grid } from '@material-ui/core';
import RotateRight from '@material-ui/icons/RotateRight';
import RotateLeft from '@material-ui/icons/RotateLeft';
import Rotate90 from '@material-ui/icons/Rotate90DegreesCcw';
import CloudUpload from '@material-ui/icons/CloudUpload';
// parts
import { CloseBackButton } from '../parts/CloseBackButton';
import KansatsuKirokuEdit from '../parts/KansatsuKirokuEdit';
// import KansatsuKirokuScoreEdit from '../parts/KansatsuKirokuScoreEdit'; // obsrec
import KansatsuKirokuScoreEditForObsrec from '../parts/KansatsuKirokuScoreEditForObsrec'; // obsrec
import SelectPicture from '../SelectPicture';
// import { InferenceResultObsrecView } from '../parts/InferenceResultObsrecView';
// models
import { SiteInfo } from '../../models/SiteInfo';
import { KansatsuKirokuObsrec } from '../../models/KansatsuKirokuObsrec';
// import { KansatsuKirokuObsrecScore } from '../../models/KansatsuKirokuObsrecScore'; // KansatsuKirokuObsrec と 統合
import { InferenceResultObsrec } from '../../models/InferenceResultObsrec';
// redux state
import { IAppState } from '../../redux/modules';
import { SiteInfoListObsrecState } from '../../redux/modules/siteInfoListObsrec';
import { KansatsuKirokuObsrecState } from '../../redux/modules/kansatsuKirokuObsrec';
import { InferenceResultObsrecState } from '../../redux/modules/inferenceObsrec';
// redux operations
import { kansatsuKirokuObsrecOperations } from '../../redux/modules';
import { inferenceResultObsrecOperations } from '../../redux/modules';

// @ts-ignore
const createObjectURL = (window.URL || window.webkitURL).createObjectURL || window.createObjectURL;

const styles = {
  contentBase: {
    padding: '20px',
    marginBottom: '20px'
  },
};

// このページのProps(情報・関数)の定義
interface OwnProps {
  match: any; // withRouterにより設定される
  sites: SiteInfoListObsrecState;
  history: H.History;
  inferenceResult: InferenceResultObsrecState;
  kansatsuKirokuObsrec: KansatsuKirokuObsrecState;
  clear: () => void;
  execute: ({ koujiBangou, inferenceId, imageStr, contentType }
    : { koujiBangou: string, inferenceId: string, imageStr: string, contentType: string }) => any;
  reset: () => any;
  getRecord: ({ koujiBangou, key, completeHandler }
    : { koujiBangou: string, key: string, completeHandler: () => any }) => any;
  postRecord: (record: KansatsuKirokuObsrec, originalImageStr: string, originalImageContentType: string, completeHandler: () => any) => any;
  getLatestRecord: ({ koujiBangou, completeHandler }
    : { koujiBangou: string, completeHandler: () => any }) => any;
}

// このページで利用するstateの定義
interface OwnState {
  // 選択したファイルの内容
  sourceImage: string;
  // プレビューが設定されているか
  isSetPreview: boolean;
  // 工事現場の情報
  site: SiteInfo;
  // 推論ID(写真IDのこと)
  inferenceId: string;

  // 細分化 行サイズ
  lineNum: number;
  // 細分化 列サイズ
  columnNum: number;
  // 観察項目名
  observationNames: string[];
  // 観察項目_説明
  observationDescriptions: string[];
  // 総合評価初期値用
  defaultInferenceResultObsrec: InferenceResultObsrec[];

  // 評価値確定がステップルールの場合に必要な要素
  targetStepRuleObservationNames: string[];
  // 評価値確定が最頻値ルールの場合に必要な要素
  targetModeRuleObservationNames: string[];
  // 評価値確定が平均<スコア重複排除前提>ルールの場合に必要な要素
  targetMeanDeduplicationRuleObservationNames: string[];
  // 評価値確定が平均<一般>ルールの場合に必要な要素
  targetMeanGeneralRuleObservationNames: string[];
  topBadsideSize: number;
  leftBadsideSize: number;
  rightBadsideSize: number;
};

class InferenceObsrecPage extends React.Component<OwnProps, OwnState>{
  private cropperElement;
  private previewCanvasElement;
  private previewCanvasElementOrg;
  private kansatsuKirokuObsrecEditElement;
  private kansatsuKirokuObsrecScoreEditElement;

  // private croppedImgElement: HTMLImageElement | null;
  constructor(props: OwnProps) {
    super(props);
    this.state = {
      sourceImage: '',
      isSetPreview: false,
      site: new SiteInfo(),
      inferenceId: '',
      lineNum: 0,
      columnNum: 0,
      observationNames: [],
      observationDescriptions: [],
      defaultInferenceResultObsrec: [],
      // 評価値確定がステップルールの場合に必要な要素
      targetStepRuleObservationNames: [],
      // 評価値確定が最頻値ルールの場合に必要な要素
      targetModeRuleObservationNames: [],
      // 評価値確定が平均<スコア重複排除前提>ルールの場合に必要な要素
      targetMeanDeduplicationRuleObservationNames: [],
      // 評価値確定が平均<一般>ルールの場合に必要な要素
      targetMeanGeneralRuleObservationNames: [],
      topBadsideSize: 0,
      leftBadsideSize: 0,
      rightBadsideSize: 0,
    };
  }

  /**
   * 以下のルールで推論IDを生成する
   * 工事番号-YYYYMMDDHHmmss-UUIDv4
   */
  generateInferenceId(): string {
    return `${this.props.match.params.koujibangou
      }-${moment().format('YYYYMMDDHHmmss')
      }-${uuidv4()
      }`;
  }

  /**
   * 画像ファイルが選択されたらStateを更新する。
   * stateがCropperのsrcに設定されているのでCropperに画像が表示される
   */
  pictureFileSelected(src: string) {
    // ファイルが選択されたときだけ画像を設定する.
    if (src) {
      this.setState({ sourceImage: src });
    }
  }
  componentDidMount() {
    // このページの工事番号
    const koujiBangou = this.props.match.params.koujibangou;
    // このページの工事情報
    const siteInfo = this.props.sites.items.find((item) => (item.koujiBangou === koujiBangou));
    // 工事情報が不正な場合はリストに戻る
    if (!siteInfo) {
      this.props.history.replace('/obsrec/sitelist');
      return;
    }
    const lineNumInfo = siteInfo.lineNum;
    const columnNumInfo = siteInfo.columnNum;
    const observationNamesInfo = siteInfo.observationNames;
    const observationDescriptionsInfo = siteInfo.observationDescriptions;
    const obsrecWeightsInfo = siteInfo.obsrecWeights;
    const tmpdefaultInferenceResultObsrec : InferenceResultObsrec[] = [];
    const targetStepRuleObservationNamesInfo = siteInfo.targetStepRuleObservationNames;
    const targetModeRuleObservationNamesInfo = siteInfo.targetModeRuleObservationNames;
    const targetMeanDeduplicationRuleObservationNamesInfo = siteInfo.targetMeanDeduplicationRuleObservationNames;
    const targetMeanGeneralRuleObservationNamesInfo = siteInfo.targetMeanGeneralRuleObservationNames;
    const topBadsideSizeInfo = siteInfo.topBadsideSize;
    const leftBadsideSizeInfo = siteInfo.leftBadsideSize;
    const rightBadsideSizeInfo = siteInfo.rightBadsideSize;

    observationNamesInfo.map((observationName) => {
      obsrecWeightsInfo.map((obsrecWeight) => {
        if (obsrecWeight.obsrecName === observationName){
          tmpdefaultInferenceResultObsrec.push(
            {
              'observation': obsrecWeight.obsrecKey,
              'observation_name': observationName,
              'weight': obsrecWeight.weight,
              'overlay_img_bucket': '',
              'overlay_img_key' : '',
              'overlay_img_presigned_url': '',
              'result_score' : {
                'left': {
                  'mode': '',
                  'mean': ''
                },
                'top': {
                  'mode': '',
                  'mean': ''
                },
                'right': {
                  'mode': '',
                  'mean': ''
                }
              }
            }
          )
        }
      })
    })
    this.setState({
      site: siteInfo,
      lineNum: lineNumInfo,
      columnNum: columnNumInfo,
      observationNames: observationNamesInfo,
      observationDescriptions: observationDescriptionsInfo,
      defaultInferenceResultObsrec : tmpdefaultInferenceResultObsrec,
      targetStepRuleObservationNames: targetStepRuleObservationNamesInfo,
      targetModeRuleObservationNames: targetModeRuleObservationNamesInfo,
      targetMeanDeduplicationRuleObservationNames: targetMeanDeduplicationRuleObservationNamesInfo,
      targetMeanGeneralRuleObservationNames: targetMeanGeneralRuleObservationNamesInfo,
      topBadsideSize: topBadsideSizeInfo,
      leftBadsideSize: leftBadsideSizeInfo,
      rightBadsideSize: rightBadsideSizeInfo,
    });
    this.props.getLatestRecord({
      koujiBangou,
      completeHandler: () => {
        // @ts-ignore
      }
    });

  }
  componentWillUnmount() {
    this.props.reset();
  }
  /**
   * cropされた画像を縮小してプレビュー表示する
   */
  previewImage() {
    // プレビューを表示するcanvas
    const previewCanvasContext = this.previewCanvasElement.getContext('2d');
    // 切り抜かれたcanvas
    const croppedCanvas = this.cropperElement.cropper.getCroppedCanvas();
    // プレビュー領域を切り抜き領域のサイズに合わせる
    this.previewCanvasElement.width = this.state.site.cropImageWidth;
    this.previewCanvasElement.height = this.state.site.cropImageHeight;
    previewCanvasContext.drawImage(
      croppedCanvas, // 描画内容
      0, 0, croppedCanvas.width, croppedCanvas.height, // 元canvasから取得する描画領域
      0, 0, this.previewCanvasElement.width, this.previewCanvasElement.height
    );

    const previewCanvasContextOrg = this.previewCanvasElementOrg.getContext('2d');
    this.previewCanvasElementOrg.width = this.state.site.cropImageWidth;
    this.previewCanvasElementOrg.height = this.state.site.cropImageHeight;
    previewCanvasContextOrg.drawImage(
      croppedCanvas, // 描画内容
      0, 0, croppedCanvas.width, croppedCanvas.height, // 元canvasから取得する描画領域
      0, 0, this.previewCanvasElementOrg.width, this.previewCanvasElementOrg.height
    );

    const lineNum = this.state.lineNum;
    const columnNum = this.state.columnNum;
    previewCanvasContext.strokeStyle = 'white';

    // 横線の描画
    for (let i = 1; i < lineNum; i++) {
      const startY = i / lineNum * this.previewCanvasElement.height;
      const startX = 0
      const endY = startY
      const endX = this.previewCanvasElement.width
      previewCanvasContext.beginPath();
      previewCanvasContext.moveTo(startX, startY);
      previewCanvasContext.lineTo(endX, endY);
      previewCanvasContext.stroke();
    }
    // 縦線の描画
    for (let i = 1; i < columnNum; i++) {
      const startY = 0;
      const startX = i / columnNum * this.previewCanvasElement.width;
      const endY = this.previewCanvasElement.height;
      const endX = startX
      previewCanvasContext.beginPath();
      previewCanvasContext.moveTo(startX, startY);
      previewCanvasContext.lineTo(endX, endY);
      previewCanvasContext.stroke();
    }

    previewCanvasContext.textAlign = "center";
    previewCanvasContext.font = "bold 30px 'sans-serif'";
    let x = 0;
    let y = 0;
    let positionStr = ''
    for (let iLine = 0; iLine < lineNum; iLine ++ ) {
      for (let iCol = 0 ; iCol < columnNum; iCol ++ ) {
        positionStr = (iLine+1).toString() + '-' + (iCol+1).toString();
        x = (0.5 + iCol) * this.state.site.cropImageWidth / columnNum;
        y = (0.5 + iLine) * this.state.site.cropImageHeight / lineNum;

        previewCanvasContext.fillStyle = '#FFFFFF';
        previewCanvasContext.globalAlpha = 1;
        previewCanvasContext.fillText(positionStr, x, y);

        previewCanvasContext.strokeStyle = "#000000";
        previewCanvasContext.globalAlpha = 1;
        previewCanvasContext.strokeText(positionStr, x, y);

      }
    }

    this.setState({ isSetPreview: true });
  }

  // 画像を回転させる
  rotate(dig: number) {
    this.cropperElement.cropper.rotate(dig);
    console.log('cropper image rotate :', `${this.cropperElement.getImageData().rotate}`);
    console.log('cropper naturalWidth x naturalHeight:', `${this.cropperElement.getCanvasData().naturalWidth} x ${this.cropperElement.getCanvasData().naturalHeight} = ${this.cropperElement.getCanvasData().naturalWidth * this.cropperElement.getCanvasData().naturalHeight}`);
  }

  /**
   * 診断を実行する
   */
  execute() {
    // base64で取得する
    // 'Data:image/jpeg;base64,iVBORw....'の形なので','以前を除去する
    // const dataUrl = this.previewCanvasElement.toDataURL('image/jpeg');
    const dataUrl = this.previewCanvasElementOrg.toDataURL('image/jpeg');
    const imageStr = dataUrl.replace(/^.*,/, '');
    const match = dataUrl.match(/data:(.*?);/i);
    // 正規表現でContentTypeを取り出し
    const contentType = (match && match.length >= 2) ? match[1] : '';
    // 推論ID
    const inferenceId = this.generateInferenceId()
    this.setState({ inferenceId });
    const koujiBangou = this.props.match.params.koujibangou;
    this.props.execute({ koujiBangou, inferenceId, imageStr, contentType });
  }

  /**
   * データを登録する
   */
  register() {
    // 登録するレコード
    const record = { ...this.props.kansatsuKirokuObsrec.item };
    record.koujiBangou = this.props.match.params.koujibangou;
    // 新規作成ならキーを生成する
    record.key = uuidv4();;
    const kansatsuKirokuObsrecEditData = this.kansatsuKirokuObsrecEditElement.get();
    record.kansatsuDate = kansatsuKirokuObsrecEditData.kansatsuDate;
    record.sokutenNumber = kansatsuKirokuObsrecEditData.sokutenNumber;
    record.danmenNumber = kansatsuKirokuObsrecEditData.danmenNumber;
    record.kyori = kansatsuKirokuObsrecEditData.kyori;
    record.kansatsuDateMemo = kansatsuKirokuObsrecEditData.kansatsuDateMemo;
    record.sokutenNumberMemo = kansatsuKirokuObsrecEditData.sokutenNumberMemo;
    record.danmenNumberMemo = kansatsuKirokuObsrecEditData.danmenNumberMemo;
    record.kyoriMemo = kansatsuKirokuObsrecEditData.kyoriMemo;
    // record.inferenceResultObsrecJsonStr = JSON.stringify(this.props.inferenceResult.results);
    // record.inferenceAdditionalResultObsrecJsonStr = JSON.stringify(this.props.inferenceResult.additionalResult);
    record.inferenceId = this.state.inferenceId;
    record.croppedImageBucket = this.props.inferenceResult.croppedImage.bucket;
    record.croppedImageKey = this.props.inferenceResult.croppedImage.key;
    record.freeInputs = kansatsuKirokuObsrecEditData.freeInputs;
    record.freeInputsJsonStr = JSON.stringify(kansatsuKirokuObsrecEditData.freeInputs);

    const kansatsuKirokuObsrecScoreEditElementData = this.kansatsuKirokuObsrecScoreEditElement.get()
    record.observationsScores = kansatsuKirokuObsrecScoreEditElementData.observationsScores;
    record.observationsScoresJsonStr = JSON.stringify(kansatsuKirokuObsrecScoreEditElementData.observationsScores);
    record.inferenceResultObsrecJsonStr = JSON.stringify(kansatsuKirokuObsrecScoreEditElementData.resultHuman);
    record.inferenceAdditionalResultObsrecJsonStr = JSON.stringify(kansatsuKirokuObsrecScoreEditElementData.additionalResultHuman);

    // 新規登録時は作成日時と更新日時は同一
    record.createdAt = moment().format();
    record.lastModifiedAt = record.createdAt;

    // base64で取得する
    // 'Data:image/jpeg;base64,iVBORw....'の形なので','以前を除去する
    const originalImageStr = this.state.sourceImage.replace(/^.*,/, '');
    const match = this.state.sourceImage.match(/data:(.*?);/i);
    // 正規表現でContentTypeを取り出し
    const originalImageContentType = (match && match.length >= 2) ? match[1] : '';

    this.props.postRecord(
      record,
      originalImageStr,
      originalImageContentType,
      () => {
        // 登録完了したら編集画面に移動する
        this.props.history.replace(`/obsrec/kansatsukiroku/${record.koujiBangou}/${record.key}`);
      }
    );
  }

  toggleByDevice() {
    // if (navigator.userAgent.indexOf('iPhone') > 0 || navigator.userAgent.indexOf('iPad') > 0) {
    //   return {
    //     display: 'block',
    //     width: this.state.site.cropImageWidth,
    //     height: this.state.site.cropImageHeight,
    //     // position: '-webkit-sticky' as '-webkit-sticky', /* ios */
    //     position: 'sticky' as 'sticky',
    //     zIndex: 2,
    //     padding: '20px',
    //     marginBottom: '20px',
    //     top: '0px',
    //     left: '30px',
    //   }
    // }
    return {
      display: 'block',
      width: this.state.site.cropImageWidth,
      height: this.state.site.cropImageHeight,
      position: 'sticky' as 'sticky',
      zIndex: 2,
      padding: '20px',
      marginBottom: '20px',
      top: '0px',
      left: '30px',
    }
  }

  render() {
    const site = this.state.site || new SiteInfo();
    return (
      <div>
        <Paper style={{ padding: '10px' }}>
          <Typography variant="h4" style={{ marginBottom: '10px' }}>
            {site.koujiBangou} : {site.name}
          </Typography>
          {/* <Typography variant="body2">[細分化画像]</Typography> */}
          <Typography variant="h6">① 写真を撮影または選択</Typography>
          <Paper style={styles.contentBase}>
            <SelectPicture
              color="secondary"
              onFileSelected={(str) => this.pictureFileSelected(str)}
            />
          </Paper>
          <Typography variant="h6">② 画像位置・サイズを調整</Typography>
          <Paper style={styles.contentBase}>

            <Typography variant="body2">青色の枠に切羽画像を合わせてください。</Typography>
            <Cropper
              ref={(r) => {
                this.cropperElement = r;
              }}
              src={this.state.sourceImage}
              style={{
                width: '100%',
                height: 400
              }}
              dragMode="move"
              // Cropper.js options
              aspectRatio={this.state.site.cropImageWidth / this.state.site.cropImageHeight} // 湯の上の画像の実際値
              guides={false}
            />
            {/* <Typography variant="body2">診断画像サイズ　幅: {this.state.site.cropImageWidth}px, 高さ: {this.state.site.cropImageHeight}px</Typography> */}

            <Grid container spacing={16} style={{ marginTop: '10px' }} >
              <Grid item xs={4}>
                <Button
                  disabled={!this.state.sourceImage}
                  variant="contained"
                  onClick={() => this.rotate(1)}
                  fullWidth
                >
                  <RotateRight />
                </Button>
              </Grid>
              <Grid item xs={4}>
                <Button
                  disabled={!this.state.sourceImage}
                  variant="contained"
                  onClick={() => this.rotate(-1)}
                  fullWidth
                >
                  <RotateLeft />
                </Button>
              </Grid>
              <Grid item xs={4}>
                <Button
                  disabled={!this.state.sourceImage}
                  variant="contained"
                  onClick={() => this.rotate(-30)}
                  fullWidth
                >
                  <Rotate90 /> 30°
              </Button>
              </Grid>
            </Grid>
            <Button
              color="secondary"
              disabled={!this.state.sourceImage}
              variant="contained"
              fullWidth
              style={{ marginTop: '10px' }}
              onClick={() => this.previewImage()}
            >
              切り取り画像をプレビュー
          </Button>
          </Paper>
          <Typography variant="h6">③ 評価値を入力する</Typography>

          <canvas
            style={this.toggleByDevice()}
            ref={(r) => {
              if (r) {
                this.previewCanvasElement = r;
              }
            }}
          />
          <canvas
            style={{
              display: 'none',
              width: this.state.site.cropImageWidth,
              height: this.state.site.cropImageHeight,
              position: 'sticky' as 'sticky',
              zIndex: 2,
              padding: '20px',
              marginBottom: '20px',
              top: '0px',
              left: '30px',
            }}
            ref={(r) => {
              if (r) {
                this.previewCanvasElementOrg = r;
              }
            }}
          />
          <Paper style={styles.contentBase}>
            <Button
              variant="contained"
              color="secondary"
              disabled={!this.state.isSetPreview}
              fullWidth
              style={{
                marginTop: '10px'
              }}
              onClick={() => {
                this.execute();
              }}
            >
              <CloudUpload style={{ marginRight: '5px' }} />
            送信して位置を確定
          </Button>
          </Paper>

          <Typography variant="h6">④ 観察記録</Typography>
          <Paper
            style={styles.contentBase}
          >
            <div style={{
              display: this.props.inferenceResult.loaded ? 'block' : 'none',
              width: this.state.site.cropImageWidth,
              padding: '20px',
              marginBottom: '20px',
            }}>
              <KansatsuKirokuScoreEditForObsrec
                disabled={false}
                // data={this.props.kansatsuKirokuObsrec.item}
                data={this.props.kansatsuKirokuObsrec.item.observationsScores}
                lineNum={this.state.lineNum}
                columnNum={this.state.columnNum}
                observationNames={this.state.observationNames}
                observationDescriptions={this.state.observationDescriptions}
                // result={this.props.inferenceResult.results}
                result={this.state.defaultInferenceResultObsrec}
                cropImageWidth={site.cropImageWidth}
                // 評価値確定がステップルールの場合に必要な要素
                targetStepRuleObservationNames={this.state.targetStepRuleObservationNames}
                targetModeRuleObservationNames={this.state.targetModeRuleObservationNames}
                targetMeanDeduplicationRuleObservationNames={this.state.targetMeanDeduplicationRuleObservationNames}
                targetMeanGeneralRuleObservationNames={this.state.targetMeanGeneralRuleObservationNames}
                topBadsideSize={this.state.topBadsideSize}
                leftBadsideSize={this.state.leftBadsideSize}
                rightBadsideSize={this.state.rightBadsideSize}

                ref={(r) => {
                  if (r) {
                    this.kansatsuKirokuObsrecScoreEditElement = r;
                  }
                }}
              />

              <KansatsuKirokuEdit
                disabled={false}
                data={this.props.kansatsuKirokuObsrec.item}
                ref={(r) => {
                  if (r) {
                    this.kansatsuKirokuObsrecEditElement = r;
                  }
                }}
              />
            </div>
            <Button
              variant="contained"
              color="secondary"
              disabled={!this.props.inferenceResult.loaded}
              fullWidth
              onClick={() => this.register()}
            >
              <CloudUpload style={{ marginRight: '5px' }} />
            診断結果と観察記録を保存
          </Button>
          </Paper>
          <CloseBackButton history={this.props.history} />
        </Paper>
      </div>
    );
  }
}

// ReactComponentがPropsとして利用する関数とreduxが行う具体的処理の対応定義を与える
function mapDispatchToProps(dispatch: Dispatch<Action<any>>) {
  return {
    execute: ({ koujiBangou, inferenceId, imageStr, contentType }) => {
      inferenceResultObsrecOperations.execute({ koujiBangou, inferenceId, imageStr, contentType })(dispatch);
    },
    getRecord: ({ koujiBangou, key, completeHandler }) => {
      kansatsuKirokuObsrecOperations.get({ koujiBangou, key })(dispatch)
        .then(() => completeHandler());
    },
    postRecord: (record, originalImageStr, originalImageContentType, completeHandler) => {
      kansatsuKirokuObsrecOperations.post(record, originalImageStr, originalImageContentType)(dispatch)
        .then(() => completeHandler());
    },
    reset: () => {
      inferenceResultObsrecOperations.reset()(dispatch);
      kansatsuKirokuObsrecOperations.resetRecord()(dispatch);
    },
    getLatestRecord: ({ koujiBangou, completeHandler }) => {
      kansatsuKirokuObsrecOperations.getLatestRecord({ koujiBangou })(dispatch)
        .then(() => completeHandler());
    },
  };
}

// Storeが持つstateの中からReactComponentがPropsとして利用するstateに対応定義を与える
function mapStateToProps(appState: IAppState) {
  return {
    user: appState.user,
    sites: appState.siteInfoListObsrec,
    inferenceResult: appState.inferenceResultObsrec,
    kansatsuKirokuObsrec: appState.kansatsuKirokuObsrec
  };
}

// Reduxの資産(Storeや処理実態)をReactComponentに利用させるコネクションを張る
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InferenceObsrecPage);



// WEBPACK FOOTER //
// ./src/components/obsrec/InferenceObsrecPage.tsx